var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.334 2.99967H13.6673V4.33301H12.334V12.9997C12.334 13.1765 12.2637 13.3461 12.1387 13.4711C12.0137 13.5961 11.8441 13.6663 11.6673 13.6663H2.33398C2.15717 13.6663 1.9876 13.5961 1.86258 13.4711C1.73756 13.3461 1.66732 13.1765 1.66732 12.9997V4.33301H0.333984V2.99967H3.66732V0.999674C3.66732 0.822863 3.73756 0.653294 3.86258 0.52827C3.9876 0.403246 4.15717 0.333008 4.33398 0.333008H9.66732C9.84413 0.333008 10.0137 0.403246 10.1387 0.52827C10.2637 0.653294 10.334 0.822863 10.334 0.999674V2.99967ZM11.0007 4.33301H3.00065V12.333H11.0007V4.33301ZM5.00065 6.33301H6.33398V10.333H5.00065V6.33301ZM7.66732 6.33301H9.00065V10.333H7.66732V6.33301ZM5.00065 1.66634V2.99967H9.00065V1.66634H5.00065Z",
    fill: "#677684"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.5bc14567.svg";
export { ForwardRef as ReactComponent };